export enum ENotificationType {
	READ = "read",
	ACTION = "action",
	BROADCAST = "broadcast",
	EMAIL_FAILURE = "email_failure",
}
